import { useState }  from "react";
import MaskedInput from "react-text-mask";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleRight, faMagnifyingGlass, faEnvelopesBulk } from '@fortawesome/free-solid-svg-icons';
import Alert from 'react-bootstrap/Alert';

import Modal from "./ViewModal";
import ModalSoporte from "./ModalSoporte";

import { Form, Row, Col, Button, Spinner, Container } from "react-bootstrap";

// hook personalizado
import { useForm } from "../hooks/useForm";

const year = new Date().getFullYear();
const month = new Date().getMonth();

const meses = [
  { name: "Enero", value: 1 },
  { name: "Febrero", value: 2 },
  { name: "Marzo", value: 3 },
  { name: "Abril", value: 4 },
  { name: "Mayo", value: 5 },
  { name: "Junio", value: 6 },
  { name: "Julio", value: 7 },
  { name: "Agosto", value: 8 },
  { name: "Septiembre", value: 9 },
  { name: "Octubre", value: 10 },
  { name: "Noviembre", value: 11 },
  { name: "Diciembre", value: 12 },
];

let anios = new Array();
for (let i = year; i >= year - 10; i--) {
  anios.push({ name: i, value: i });
}

const initialForm = {
  sistema: "",
  cuit: "",
  periodo: "",
  anio: year,
  mes: month,
};

const validationsForm = (form) => {
  let errors = {};
  let regexpCuit = /^[0-9]{2}[-][0-9]{8}[-][0-9]{1}$/;
  //  let regexpPeriodo = /^[0-9]{4}[/][0-9]{2}$/;

  if (!form.sistema) {
    errors.sistema = "El campo 'SISTEMA' es requerido";
  }

  if (!form.cuit.trim()) {
    errors.cuit = "El campo 'CUIT' es requerido";
  } else if (!regexpCuit.test(form.cuit.trim())) {
    errors.cuit = "El campo 'CUIT' debe ser completado";
  }
  return errors;
};

function Formulario() {  
  const year = new Date().getFullYear();
  const month = new Date().getMonth();

  //validations
  const {
    form,
    errors,
    loading,
    response,
    showModal,
    errorAPI,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useForm(initialForm, validationsForm);

  const [showModalSop,setShowModalSop]=useState(false);

  
  return (
    <>
      <section className="mt-2 w-100">
        <Form onSubmit={handleSubmit}>
          <fieldset disabled={loading}>
            <Container className="pl-0" >             
              {/* ROW CUIT ANIO MES */}             
              <Row className="">
                {/* CUIT */ }
                <Col  lg={4} xs={12}  className="">
                  <label htmlFor="cuit">CUIT</label>
                  <div className="input-container select-flex">
                  <FontAwesomeIcon icon={faMagnifyingGlass} className="icon" />                    
                  <MaskedInput
                        type="text"
                        id="cuit"
                        name="cuit"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onKeyDown={handleChange}
                        onKeyUp={handleChange}
                        value={form.cuit}
                        required
                        placeholder="99-99999999-9"
                        className={
                          errors.cuit
                            ? "w-100  input-cuit"
                            : "w-100  input-cuit"
                        }
                        mask={[
                          /[1-9]/,
                          /\d/,
                          "-",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          "-",
                          /\d/,
                        ]}
                      />
                    </div>                    
                </Col>
                {/* ANIO */ }
                <Col lg={4} xs={12} className="">
                      <label htmlFor="anio">Año</label>                    
                      <Form.Select
                        name="anio"
                        id="anio"
                        defaultValue={year}
                        onChange={handleChange}
                        className="txt-grey "
                        required
                      >
                        {anios.map((anio, idx) => {
                          return (
                            <option value={anio.value} key={anio.value} className="txt-grey">
                              {anio.name}
                            </option>
                          );
                        })}
                      </Form.Select>
                </Col>
                {/* MES */ }
                <Col lg={4} xs={12}  className="">
                      <label htmlFor="mes">Mes</label>
                      <Form.Select
                        name="mes"
                        id="mes"
                        onChange={handleChange}
                        defaultValue={month}
                        className="txt-grey"
                        required
                      >
                        {meses.map((mes, idx) => {
                          return (
                            <option value={mes.value} key={mes.value} className="txt-grey">
                              {mes.name}
                            </option>
                          );
                        })}
                      </Form.Select>                    
                </Col>        
              </Row>
               {/* ERRORES */} 
              <Row className="mt-1">
                <Col>
                   { errors.cuit && (
                        <ul className="txt-red size-8 txt-left p-0 w-100">
                        {errors.cuit}
                      </ul>
                   )}
                </Col>
              </Row>
               {/* SISTEMA */}
              <Row>
                <Col xs={12} className="mt-4">
                  Seleccione el sistema:
                </Col>
              </Row>
              <Row className="mb-4 mt-2">                 
                <Col lg={4} xs={4} className="txt-left display-block txt-bold" >
                  <Form.Check
                    inline
                    label="SIRCREB"
                    name="sistema"
                    type="radio"
                    id="1"
                    value="sircreb"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onClick={handleChange}
                    required
                  />
                </Col>
                <Col lg={4}  xs={4} className="txt-left display-block txt-bold" >
                  <Form.Check
                    inline
                    label="SIRCUPA"
                    name="sistema"
                    type="radio"
                    id="2"
                    value="sircupa"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onClick={handleChange}
                    required                    
                  />
                </Col>  
                <Col lg={4}  xs={4} className="txt-left display-block txt-bold" >
                  <Form.Check
                    inline
                    label="SIRTAC"
                    name="sistema"
                    type="radio"
                    id="3"
                    value="sirtac"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onClick={handleChange}
                    required                    
                  />
                </Col>  
                <Col xs={12}>{errors.sistema && (
                    <ul className="txt-red size-8 txt-left p-0 m-0">
                      {errors.sistema}
                    </ul>
                  )}</Col>
                
              </Row>              
              <Row>
                <Col xs={12} className="text-left">
                  {errors.periodo && (
                    <p className="txt-red">{errors.periodo}</p>
                  )}
                  {errorAPI && (
                    <Alert key="msgerror" variant="danger">
                        Ha ocurrido un error inesperado, por favor intente nuevamente en unos minutos.
                    </Alert>)
                  }
                </Col>
              </Row>              
            </Container>
            <Row className="txt-center"> 
                <Col className="pt-4 pr-0 txt-left">                  
                  <Button variant="outline-primary" className="boton-gral" onClick={()=>{setShowModalSop(true)}} >
                    <FontAwesomeIcon icon={faEnvelopesBulk} className="font-awesome-icon" aria-hidden="true" />
                    Soporte
                  </Button>
                </Col>
                <Col className="pt-4 pr-0 txt-right">
                  <Button type="submit" className="boton " >
                        <FontAwesomeIcon icon={faCircleRight} className="font-awesome-icon" />                        
                            Consultar
                            {loading ? (
                              <Spinner
                                as="span"
                                variant="light"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                animation="border"
                                className="ml-3px"
                              />
                            ) : (
                              ""
                            )}                            
                  </Button>
                </Col>
            </Row>
          </fieldset>
        </Form>
      </section>
      
      {showModal && <Modal data={response} sistema={form.sistema} cuit={form.cuit} anio={form.anio} mes={form.mes} />}
      {showModalSop && <ModalSoporte showModalSop={showModalSop} setShowModalSop={setShowModalSop}/>}
      
      
    </>
  );
}

export default Formulario;
